import React from 'react'
import * as personStyles from '../../styles/project-modules/bills/person.module.less'
import LazyLoad from 'react-lazyload'
import chamberNames from '../../data/sfc/chamber_names.json'

const partyMap = {
  1: { label: 'D' },
  2: { label: 'R' },
  3: { label: 'Ind' },
  4: { label: 'G' },
  5: { label: 'L' },
  6: { label: 'Nonpartisan' },
}

function Person({ name, district, img, party, className, show_more=null, MARKET_KEY=null }) {

  const partyLabel = partyMap[party] ? partyMap[party].label : null

  return (
    <>
    <span className={`${personStyles.container} ${className ? className : ''}`}>
      {img && (
        <figure className={personStyles.img}>
          <LazyLoad once>
            <img src={img} alt={`Portrait of ${name}`} />
          </LazyLoad>
        </figure>
      )}{' '}
      <span>
        {district ? (
          <>
            <b>{name}</b>, {district}
            {partyLabel && (
              <span className={personStyles[`party${partyLabel}`]}>{partyLabel}</span>
            )}
          </>
        ) : (
          <>{name}
          {partyLabel && (
            <span className={personStyles[`party${partyLabel}`]}>{partyLabel}</span>
          )}
          </>
        )}
      </span>
    </span>
    { show_more && 
      <span className={`${personStyles.container} ${className ? className : ''}`}>
          and {show_more.length - 1} more
      </span>
    }
    </>
  )
}

export default Person
